module.exports = __webpack_public_path__ + "img/wide.0bc328b4.jpg";